import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { AppSettings } from "src/config/config";

@Injectable({
  providedIn: "root",
})
export class IdCardService {
  constructor(private http: HttpClient) {}
  private URL3 = AppSettings.API_ENDPOINT_V3;

  getServiceListData() {
    const authToken = localStorage.getItem("usertoken");
    const headers = new HttpHeaders().append("token", authToken);
    const lang = "en";
    return this.http
      .get(
        this.URL3 + `/get/id/card/service/and/template/details?lang=${lang}`,
        { headers }
      )
      .pipe(map((res) => res));
  }

  getStaffServiceListData() {
    const authToken = localStorage.getItem("usertoken");
    const headers = new HttpHeaders().append("token", authToken);
    const lang = "en";
    return this.http
      .get(
        this.URL3 + `/get/id/card/service/and/template/details/for/staff?lang=${lang}`,
        { headers }
      )
      .pipe(map((res) => res));
  }

  idJobCancel(jobId) {
    const lang = "en";
    const params = { lang: lang, jobDetailId: jobId };
    const headers = new HttpHeaders()
      .append("Content-Type", "application/json")
      .append("token", localStorage.getItem("usertoken"));
    const url = `${this.URL3}/cancel/scheduled/id/card/job`;
    return this.http.put(url, params, { headers }).pipe(map((res) => res));
  }


    staffIdJobCancel(jobId) {
    const lang = "en";
    const params = { lang: lang, jobDetailId: jobId };
    const headers = new HttpHeaders()
      .append("Content-Type", "application/json")
      .append("token", localStorage.getItem("usertoken"));
    const url = `${this.URL3}/cancel/scheduled/id/card/job/for/staff`;
    return this.http.put(url, params, { headers }).pipe(map((res) => res));
  }


  getStudentListForId(jobId) {
    const lang = "en";
    const headers = new HttpHeaders()
      .append("Content-Type", "application/json")
      .append("token", localStorage.getItem("usertoken"));
    const url = `${this.URL3}/get/student/details/for/scheduled/job/for/id/card?lang=${lang}&jobDetailId=${jobId}`;
    return this.http.get(url, { headers }).pipe(map((res) => res));
  }

    getStaffListForId(jobId) {
    const lang = "en";
    const headers = new HttpHeaders()
      .append("Content-Type", "application/json")
      .append("token", localStorage.getItem("usertoken"));
    const url = `${this.URL3}/get/staff/details/for/scheduled/job/for/id/card?lang=${lang}&jobDetailId=${jobId}`;
    return this.http.get(url, { headers }).pipe(map((res) => res));
  }



    uploadExcel(body, formData) {
    const form = new FormData();
    for (const key in body) {
      if (body.hasOwnProperty(key)) {
        form.append(key, body[key]);
      }
    }
    form.append("idCardExcel", formData, formData.name); 
    const headers = new HttpHeaders()
      .append("token", localStorage.getItem("usertoken"));
    const url = `${this.URL3}/upload/excel/for/id/card/generation`;
    return this.http.post(url, form, { headers }).pipe(map((res) => res));
  }

    uploadExcelForStaff(body, formData) {
    const form = new FormData();
    for (const key in body) {
      if (body.hasOwnProperty(key)) {
        form.append(key, body[key]);
      }
    }
    form.append("idCardExcel", formData, formData.name); 
    const headers = new HttpHeaders()
      .append("token", localStorage.getItem("usertoken"));
    const url = `${this.URL3}/upload/excel/for/id/card/generation/for/staff`;
    return this.http.post(url, form, { headers }).pipe(map((res) => res));
  }


}
